// extracted by mini-css-extract-plugin
module.exports =  {"underlineText":"TooltipContainer-module__underlineText--u2xwe"};